import { Button } from "@vintecc/components";
import { IErrorContentProps } from "./types";
import Logo from "../LogoComponent/LogoComponent";
import { useAuthTranslation } from "../../services/culture/auth.translations";

const ErrorContent = (props: IErrorContentProps) => {
  const { t: tAuth } = useAuthTranslation();

  return (
    <div
      id="error"
      className="flex relative h-full sm:items-center items-start justify-center overflow-auto xl:px-64 border-solid border-10 xl:border-20 border-white"
    >
      <div className="bg-white h-1/4 w-1/3 flex flex-col justify-between text-center px-10 py-5">
        <Logo />
        <div className="text-2xl font-bold">
          {tAuth("errorContent.titlePrefix")}: {props.title}
        </div>
        <p>{props.message ?? tAuth("errorContent.defaultMessage")}</p>
        <br />
        <div className="flex justify-around">
          {props.actions?.map((action, index) => (
            <Button key={index} color={action.color} onClick={action.onClick}>
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ErrorContent;
